import {dateToReadableDate} from '@date-picker';
import _ from 'lodash';

import {
  approveProductList,
  getCycle,
  getCycleDetails,
  getDiscountFilters,
  getDiscountList,
  getFilters,
  getProductsDetailsList,
  getProductsTotalList,
  getVendorsPromotions
} from './thunk';

export const promotionCenterBuilder = (builder: any) => {
  builder
    .addCase(getCycle.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getCycle.fulfilled, (state: any, action: any) => {
      const dateConverter = (date: string) => {
        return dateToReadableDate({date: date, day: true, month: true});
      };
      const temp: any[] = action.payload?.data?.cycles?.map((item: any) => {
        if (item.state === 'threshold') {
          return {
            index: 1,
            ...item,
            title: `${dateConverter(item.discount_start_date)} - ${dateConverter(item.discount_end_date)}`
          };
        } else if (item.state === 'in_dsc') {
          return {
            index: 2,
            ...item,
            title: `${dateConverter(item.discount_start_date)} - ${dateConverter(item.discount_end_date)}`
          };
        } else if (item.state === 'in_ddc') {
          return {
            index: 3,
            ...item,
            title: `${dateConverter(item.discount_start_date)} - ${dateConverter(item.discount_end_date)}`
          };
        } else if (item.state === 'in_hold' || item.state === 'in_edsc') {
          return {
            index: 4,
            ...item,
            title: `${dateConverter(item.discount_start_date)} - ${dateConverter(item.discount_end_date)}`
          };
        }
      });

      if (temp?.length) {
        temp.sort((a, b) => a.index - b.index);
      }
      const filteredCycles = temp
        .filter((cycle) => cycle.state === 'in_dsc')
        .sort(
          (a, b) => new Date(a.deal_start_date).getTime() - new Date(b.deal_start_date).getTime()
        );

      const updatedCycles = filteredCycles.map((cycle, index) => ({
        ...cycle,
        disable: index === 0 // true for the first item, false for the rest
      }));

      const newData = [...temp.filter((cycle) => cycle.state !== 'in_dsc'), ...updatedCycles];
      const mappedData = newData.map((item: any) => ({
        ...item,
        original_state: item.state,
        state: ['in_hold', 'in_edsc'].includes(item.state) ? 'is_combined' : item.state
      }));

      const groupedData = _.groupBy(mappedData, 'state');
      state.cycleData = groupedData;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getCycle.rejected, (state: any, action: any) => {
      state.error = action.payload.message;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getProductsTotalList.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getProductsTotalList.fulfilled, (state: any, action: any) => {
      localStorage.setItem('totalProducts', JSON.stringify(action.payload.data));
      state.productsTotalList = action.payload.data;
      state.selectedItems = action.payload.data.total_selected_products;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getProductsTotalList.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getProductsDetailsList.pending, (state: any) => {
      if (!state.productsDetailsList.data?.length) state.loading += 1;
    })
    .addCase(getProductsDetailsList.fulfilled, (state: any, action: any) => {
      const temp =
        !state.filters.updated &&
        state.productsDetailsList.data &&
        state.productsDetailsList.pagination.page !== action.payload?.data.page &&
        state.productsDetailsList.data.length
          ? state.productsDetailsList.data
          : [];

      if (action.payload.data.data && action.payload.data.data.products.length) {
        action.payload.data?.data.products.map((item: any) => {
          temp.push({
            productId: item.ProductID,
            productTitle: item.ProductTitle,
            productPrice: item.ProductPrice,
            selected: state.registerCampaignDefaultSelected,
            suggestedDiscount: item.SuggestedDiscounts,
            productImageURL: item.ProductImageURL
          });
        });
      }
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.productsDetailsList = action.payload.data.data;
      state.productsDetailsList.products = temp;
    })
    .addCase(getProductsDetailsList.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(approveProductList.pending, (state: any) => {
      state.approveLoading = true;
    })
    .addCase(approveProductList.fulfilled, (state: any) => {
      state.approveLoading = false;
    })
    .addCase(approveProductList.rejected, (state: any) => {
      state.approveLoading = false;
    });

  builder
    .addCase(getFilters.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getFilters.fulfilled, (state: any, action: any) => {
      state.categoriesList = action.payload.data?.categories?.map((item: any) => {
        return {
          title: item.category_title,
          count: item.category_count,
          value: item.category_id,
          selected: false
        };
      });
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getFilters.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getDiscountList.pending, (state: any) => {
      if (!state.campaignCycle.products?.length) state.loading += 1;
    })
    .addCase(getDiscountList.fulfilled, (state: any, action: any) => {
      let temp: any = {};
      if (action.payload.data?.products) {
        if (
          state.campaignCycle?.products &&
          state.campaignCycle?.products?.length &&
          state.campaignCycle.page !== action.payload.data.page
        ) {
          temp = state.campaignCycle;
          temp.products.push(...action.payload.data.products);
        } else {
          temp = action.payload.data;
        }
      } else {
        temp = action.payload.data;
      }
      state.campaignCycle = temp;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getDiscountList.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getDiscountFilters.pending, (state: any) => {
      if (!state.cycleHistory?.cycle?.length) state.loading += 1;
    })
    .addCase(getDiscountFilters.fulfilled, (state: any, action: any) => {
      let transformedData: any[] = [];
      if (action.payload.data?.cycle?.length) {
        transformedData = action.payload.data.cycle.map((item: any) => {
          return {
            id: item.id,
            productCount: item.product_count,
            state: item.state,
            cycle_state: item.cycle_state,
            discountStartDate: item.discount_start_date,
            discountEndDate: item.discount_end_date,
            dealStartDate: item.deal_start_date,
            dealEndDate: item.deal_end_date,
            title: `${dateToReadableDate({date: item.discount_start_date, month: true, day: true})} - ${dateToReadableDate({date: item.discount_end_date, month: true, day: true})}`
          };
        });
      }

      let temp: any = [];
      if (action.payload?.data?.cycle) {
        if (
          state.cycleHistory &&
          state.cycleHistory?.cycle?.length &&
          state.cycleHistory?.page !== action.payload.data?.page
        ) {
          temp = state.cycleHistory;
          temp.cycle.push(...transformedData);
        } else {
          temp = {...action.payload.data, cycle: transformedData};
        }
      } else {
        temp = {...action.payload.data, cycle: transformedData};
      }
      state.cycleHistory = temp;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getDiscountFilters.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getCycleDetails.pending, (state: any) => {
      if (!state.cycleDetails.products?.length) state.loading += 1;
    })
    .addCase(getCycleDetails.fulfilled, (state: any, action: any) => {
      let temp: any = {};
      if (action.payload.data?.products) {
        if (
          state.cycleDetails?.products &&
          state.cycleDetails?.products?.length &&
          state.cycleDetails.page !== action.payload.data.page
        ) {
          temp = state.cycleDetails;
          temp.products.push(...action.payload.data.products);
        } else {
          temp = action.payload.data;
        }
        if (temp.state === 'in_dsc' && temp?.products?.length) {
          temp.products.map((item, tempIndex) => {
            state.productsTotalList.products.map((product) => {
              if (item.id === product.product_id) {
                temp.products[tempIndex] = {...item, selected: product.selected};
                temp.products[tempIndex].suggested_option = item.suggested_option.map(
                  (discount, suggestedDiscountIndex) => {
                    if (discount.option === product.vendor_default_discount) {
                      return (temp.products[tempIndex].suggested_option[suggestedDiscountIndex] = {
                        ...discount,
                        data: {...discount.data, selected: true}
                      });
                    } else {
                      return (temp.products[tempIndex].suggested_option[suggestedDiscountIndex] = {
                        ...discount,
                        data: {...discount.data, selected: false}
                      });
                    }
                  }
                );
              }
            });
          });
        }
      } else {
        temp = action.payload.data;
      }
      state.cycleDetails = temp;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getCycleDetails.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getVendorsPromotions.pending, (state: any) => {
      if (!state.vendorsPromotions) state.loading += 1;
    })
    .addCase(getVendorsPromotions.fulfilled, (state: any, action: any) => {
      state.vendorsPromotions = action.payload ?? null;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getVendorsPromotions.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
